import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledWrapper,
} from './SubTitle.styled';

const SubTitle = props => {
  const { children, id, isSmall, fontSize } = props;
  return (
    <StyledWrapper id={id} isSmall={isSmall} fontSize={fontSize}>
      {children}
      <a href={`#${id}`}>#</a>
    </StyledWrapper>
  )
}

SubTitle.propTypes = {
  id: PropTypes.string,
  isSmall: PropTypes.bool,
  fontSize: PropTypes.number,
}

SubTitle.defaultProps = {
  id: '',
  isSmall: false,
  fontSize: 24,
}

export default SubTitle
